export default __webpack_public_path__ + "static/media/shipped-icon.4790cc35.png";